import gql from "graphql-tag";

export default gql`
  query GetAccountPermissions($objectId: ID!) {
    getAccountPermissions(objectId: $objectId) {
      tenantId
      objectId
      revision
      grants {
        permission
        enabled
        expiresAt
      }
    }
  }
`;
